import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Accordion from 'Common/Accordion/Accordion';
import Timeline from 'Common/Timeline/Timeline';
import ItemGrid from 'Common/Grid/ItemGrid';
import GridContainer from 'Common/Grid/GridContainer';

export default class AuthorsInfoList extends PureComponent {
    /**
     * @type {Object}
     */
    static propTypes = {
        profiles: PropTypes.array.isRequired,
    };

    /**
     * @type {Object}
     */
    static contextTypes = {
        intl: PropTypes.object.isRequired,
    };

    render() {
        const { profiles } = this.props;

        return (
            <Accordion
                collapses={[{
                    title: (
                        <div className="accordion-title-wrapper round-report-accordion-title-wrapper">
                            {this.context.intl.formatMessage({ id: 'authors.info' })}
                        </div>
                    ),
                    content: (
                        <div className="accordion-body-wrapper round-report-table-wrapper">
                            <Timeline
                                stories={ profiles.map(profile => {
                                    return {
                                        body: <GridContainer>
                                            <ItemGrid md={3} className='item-grid-name-wrapper'>
                                                {this.context.intl.formatMessage({ id: 'authors.full_name' })}:
                                            </ItemGrid>
                                            <ItemGrid md={9}>
                                                {profile.name}
                                            </ItemGrid>
                                            <ItemGrid md={3} className='item-grid-name-wrapper'>
                                                {this.context.intl.formatMessage({ id: 'authors.email' })}:
                                            </ItemGrid>
                                            <ItemGrid md={9}>
                                                {profile.email}
                                            </ItemGrid>
                                            <ItemGrid md={3} className='item-grid-name-wrapper'>
                                                {this.context.intl.formatMessage({ id: 'authors.degree' })}:
                                            </ItemGrid>
                                            <ItemGrid md={9}>
                                                {profile.degree}
                                            </ItemGrid>
                                            <ItemGrid md={3} className='item-grid-name-wrapper'>
                                                {this.context.intl.formatMessage({ id: 'authors.faculty' })}:
                                            </ItemGrid>
                                            <ItemGrid md={9}>
                                                {profile.faculty}
                                            </ItemGrid>
                                            <ItemGrid md={3} className='item-grid-name-wrapper'>
                                                {this.context.intl.formatMessage({ id: 'authors.department' })}:
                                            </ItemGrid>
                                            <ItemGrid md={9}>
                                                {profile.department}
                                            </ItemGrid>
                                            <ItemGrid md={3} className='item-grid-name-wrapper'>
                                                {this.context.intl.formatMessage({ id: 'authors.university' })}:
                                            </ItemGrid>
                                            <ItemGrid md={9}>
                                                {profile.university}
                                            </ItemGrid>
                                            <ItemGrid md={3} className='item-grid-name-wrapper'>
                                                {this.context.intl.formatMessage({ id: 'authors.orcid' })}:
                                            </ItemGrid>
                                            <ItemGrid md={9}>
                                                {profile.orcid_id}
                                            </ItemGrid>
                                            <ItemGrid md={3} className='item-grid-name-wrapper'>
                                                {this.context.intl.formatMessage({ id: 'authors.researcher_id' })}:
                                            </ItemGrid>
                                            <ItemGrid md={9}>
                                                {profile.researcher_id}
                                            </ItemGrid>
                                        </GridContainer>
                                    };
                                }) }
                                classes={{
                                    timeline: 'timeline-contact-info-wrap',
                                    timelinePanel: 'timeline-contact-info-panel-wrap'
                                }}
                            />
                        </div>
                    ),
                }]}
                classes={{
                    expansionPanel: 'contact-info-accordion-collapse-wrapper',
                    expansionPanelExpanded: 'contact-info-accordion-collapse-expanded-wrapper',
                    root: 'contact-info-accordion',
                    expansionPanelSummary: 'contact-info-panel',
                    expansionPanelDetails: 'contact-info-details'
                }}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/layouts/SubmissionManagement/components/AuthorsInfoList.jsx